import React from "react";
import { Bracket, PositionedBracketRoundRobin, Seed } from "core/models/Bracket";
import { RoundRobinMatch } from "components/Brackets/RoundRobinMatch";

interface RoundRobinBracketProps {
  brackets: Bracket;
  onMatchClick?: (seed: Seed) => void;
}

export default function RoundRobinBracket({
  brackets,
  onMatchClick,
}: RoundRobinBracketProps) {
  if (!brackets?.roundRobin?.length) {
    return <div>No matches available</div>;
  }

  return (
    <div className="round-robin-bracket">
      {brackets.roundRobin.map((round, roundIndex) => (
        <div key={roundIndex} className="round-section">
          <h4>{round?.title}</h4>
          <h6>{round?.format}</h6>
          <div className="seeds-grid">
            {round.seeds.map((sd: Seed, seedIndex: number) => {
              const positionedBracket: PositionedBracketRoundRobin = {
                id: `(${roundIndex}-${seedIndex})`,
                region: "upper", 
                seed: sd,
                roundIndex, 
              };

              return (
                <RoundRobinMatch
                  key={`${roundIndex}-${seedIndex}`}
                  positionedBracket={positionedBracket}
                  width={340}
                  height={125}
                  onFocus={() => {}}
                  onClick={onMatchClick}
                />
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
